<template>
  <div class="kongjian">
    <a-row style="height: 100%">
      <a-col :span="17" style="height: 100%">
        <ShowWpsFile
          ref="showWpsFile"
          :btnShow="false"
          :fileCode="code"
          :isReadOnly="'false'"
        />
      </a-col>
      <a-col :span="7">
        <a-row class="op-row">
          <a-col :span="8" class="title">处理类型：</a-col>
          <a-col :span="14">
            <a-select style="width: 100%" placeholder="请选择" v-model="status">
              <a-select-option value="2">分稿</a-select-option>
              <a-select-option value="4">退稿</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row class="op-row" v-if="this.status === '2'">
          <a-col :span="8" class="title">责任编辑：</a-col>
          <a-col :span="14">
            <a-select
              style="width: 100%"
              placeholder="请选择"
              v-model="extraInfo.selEditor"
              @change="onEditorChange"
            >
              <a-select-option
                v-for="item in editorList"
                :value="item.userCode"
                :key="item.userCode"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row class="op-row" v-if="this.status === '2'">
          <a-col :span="8" class="title">版本：</a-col>
          <a-col :span="14">
            <a-select
              style="width: 100%"
              placeholder="请选择"
              v-model="selSectionInfo"
              @change="onSectionChange"
            >
              <a-select-option
                v-for="item in sectionInfos"
                :value="item.dicValue"
                :key="item.dicValue"
              >
                {{ item.dicValue }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row class="op-row" v-if="this.status === '2'">
          <a-col :span="8" class="title">栏目：</a-col>
          <a-col :span="14">
            <a-select
              style="width: 100%"
              placeholder="请选择"
              v-model="selColumnInfo"
            >
              <a-select-option
                v-for="item in columnInfos"
                :value="item.columnName"
                :key="item.columnName"
              >
                {{ item.columnName }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row class="op-row" v-if="this.status === '4'">
          <a-col :span="8" class="title">处理意见：</a-col>
          <a-col :span="14">
            <a-textarea
              id="textarea"
              v-model="auditOpinion"
              :autoSize="{ minRows: 4, maxRows: 8 }"
            />
          </a-col>
        </a-row>
        <div class="btn_div">
          <a-button id="cancel" name="btn" @click="cancel"> 关闭 </a-button>
          <a-button id="save" name="btn" @click="save"> 保存 </a-button>
          <a-button id="submit" name="btn" type="primary" @click="submit">
            提交
          </a-button>
        </div>
        <div class="btn_div">注：修改文档后使用Ctrl + S 保存文档</div>
        <div class="btn_div">
          <a-button id="preview" name="btn" @click="previewFile">
            文档预览
          </a-button>
        </div>
      </a-col>
    </a-row>
    <PreviewCreateFile
      ref="previewCreateFile"
      :fileId="code"
      @previewFileClose="
        () => {
          this.$refs.showWpsFile.openWps();
        }
      "
    />
  </div>
</template>

<script>
import qs from "qs";
import ShowWpsFile from "../../../commomon/ShowWpsFile.vue";
import PreviewCreateFile from "../../../commomon/PreviewCreateFile.vue";
export default {
  name: "manager",
  data() {
    return {
      code: "",
      manuscript: {},
      extraInfo: {
        selEditor: "",
        selEditorName: "",
      },
      editorList: [],
      status: "2",
      auditOpinion: "感谢来稿，未被采用。",
      sectionInfos: [],
      selSectionInfo: "",
      allColumnInfos: [],
      columnInfos: [],
      selColumnInfo: "",
      previewVisible: false,
      spinning: false,
    };
  },
  components: {
    ShowWpsFile,
    PreviewCreateFile,
  },
  created() {
    this.code = this.$route.query.code;
    this.axios
      .get("/manuscripts/queryByCode", {
        params: {
          code: this.code,
          time: new Date().getTime(),
        },
        paramsSerializer: function (p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        },
      })
      .then((res) => {
        if (res.data.code == "OK") {
          this.manuscript = res.data.data;
          this.selSectionInfo = this.manuscript.sectionInfo;
          this.axios.get("/columnInfo/listColumns").then((res) => {
            if (res.data) {
              this.allColumnInfos = [...res.data];
              this.onSectionChange(this.selSectionInfo);
            } else {
              this.utils.messageInfo(this, "error", "查询刊物版本失败！");
            }
          });
        }
      });
    this.axios
      .get("/systemUser/queryEditor", {
        params: {
          roleName: "责编",
          time: new Date().getTime(),
        },
        paramsSerializer: function (p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        },
      })
      .then((res) => {
        this.editorList = res.data;
        if (this.editorList.length != 0) {
          this.extraInfo.selEditor = this.editorList[0].userCode;
          this.extraInfo.selEditorName = this.editorList[0].name;
          for (var i = 0; i < this.editorList.length; i++) {
            if (this.editorList[i].isEdit == 1) {
              this.extraInfo.selEditor = this.editorList[i].userCode;
              this.extraInfo.selEditorName = this.editorList[i].name;
              break;
            }
          }
        }
      });
    this.axios
      .get("/reviewLog/queryReviewLog", {
        params: {
          code: this.code,
          isSubmit: 0,
          auditer: sessionStorage.getItem("userCode"),
          time: new Date().getTime(),
        },
        paramsSerializer: function (p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        },
      })
      .then((res) => {
        if (res.data != "") {
          this.status = res.data.status + "";
          this.auditOpinion = res.data.auditOpinion;
          this.selSectionInfo = res.data.sectionInfo;
          this.selColumnInfo = res.data.columnInfo;
          if (res.data.extraInfo) {
            this.extraInfo = JSON.parse(res.data.extraInfo);
          }
        }
      });
    this.axios
      .get("/dataDic/queryChild", { params: { parentCode: "section_info" } })
      .then((res) => {
        if (res.data) {
          this.sectionInfos = res.data;
        } else {
          this.utils.messageInfo(this, "error", "查询刊物版本失败！");
        }
      });
  },
  mounted() {},
  methods: {
    onEditorChange(val) {
      this.extraInfo.selEditorName = this.editorList.find(
        (item) => item.userCode == val
      ).name;
    },
    onSectionChange(val) {
      if (val) {
        this.columnInfos = [
          ...this.allColumnInfos.filter((item) => item.sectionInfo == val),
        ];
      }
    },
    cancel() {
      this.$router.push("/register");
    },
    async save() {
      this.$refs.showWpsFile.saveDoc(-1);
      let delRes = await this.deleteUncommit();
      if (delRes) {
        this.axios
          .post("/reviewLog/saveReviewLog", {
            code: this.code,
            status: this.status,
            auditer: sessionStorage.getItem("userCode"),
            auditOpinion: this.status == "2" ? "" : this.auditOpinion,
            extraInfo: JSON.stringify(this.extraInfo),
            isSubmit: 0,
            sectionInfo: this.selSectionInfo,
            columnInfo: this.selColumnInfo,
            auditStatus: this.status == 2 ? 0 : null,
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "操作成功");
              // this.$router.push("/register");
            } else {
              this.utils.messageInfo(this, "error", res.data.data);
            }
          });
      }
    },
    async submit() {
      if (this.status == 4 && this.auditOpinion == "") {
        this.utils.messageInfo(this, "error", "请填写处理意见！");
        return;
      }
      this.$refs.showWpsFile.saveDoc(-1);
      let delRes = await this.deleteUncommit();
      if (delRes) {
        this.axios
          .post("/manuscripts/audit", {
            code: this.code,
            status: this.status,
            editUserCode: this.extraInfo.selEditor,
            userCode: sessionStorage.getItem("userCode"),
            auditOpinion: this.status == "2" ? "" : this.auditOpinion,
            extraInfo: JSON.stringify(this.extraInfo),
            sectionInfo: this.selSectionInfo,
            columnInfo: this.selColumnInfo,
            isSubmit: 1,
            auditStatus: this.status == 2 ? 0 : null,
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "操作成功");
              this.$router.push("/register");
            } else {
              this.utils.messageInfo(this, "error", res.data.data);
            }
          });
      }
    },
    async deleteUncommit() {
      let res = await this.axios.post("/reviewLog/deleteReviewLog", {
        code: this.code,
        auditer: sessionStorage.getItem("userCode"),
        isSubmit: 0,
      });
      return res.data.code == "OK";
    },
    previewFile() {
      this.$refs.previewCreateFile.previewFile();
    },
  },
};
</script>

<style scoped>
.kongjian {
  height: 100%;
  background-color: #fff;
}
.kongjian .btn_div {
  text-align: center;
  margin-top: 10px;
}
.kongjian .btn_div button {
  margin: 0 5px;
}
.kongjian .title {
  height: 36px;
  line-height: 36px;
  text-align: right;
}
.kongjian .op-row {
  margin-top: 10px;
}
</style>

